module.exports = __webpack_public_path__ + "static/media/share_2.403853a8.png";